import API_DOMAIN from '../api/apiDomain';

export const getHost = () => {
  return API_DOMAIN;
};
